import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5ead2d97-7ad4-48d6-8ee4-b13556106f69/artifacts/jd65gb5i_CityWorth%20Logo.png";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="py-12 relative border-t border-slate-200 bg-white" data-testid="footer">
      <div className="container-main">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <motion.img
            src={LOGO_URL}
            alt="CityWorth"
            className="h-8 cursor-pointer"
            onClick={scrollToTop}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          />

          {/* Tagline */}
          <div className="text-center">
            <p className="text-slate-600">
              <span className="gradient-text font-semibold">CityWorth</span> — The Future of Homebuying
            </p>
          </div>

          {/* Copyright */}
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} CityWorth. All rights reserved.
          </p>
        </div>

        {/* Bottom tagline */}
        <div className="mt-8 pt-8 border-t border-slate-100 text-center">
          <p className="text-slate-500 text-sm max-w-xl mx-auto">
            Helping clients achieve homeownership while building high-growth careers
            for agents and bankers alike.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
